import { get } from "lodash"
import React, { ChangeEvent, ComponentProps } from "react"
import { useFormContext } from "react-hook-form"
import Checkbox from "../../common/commerce/checkbox/checkbox.component"
import Select from "../../common/commerce/select/select.component"
import InputWithError from "../../../ui/components/input/input-with-error.component"
import { Field } from "./fields"
import TextareaWithError from "../textarea/textarea-with-error.component"
import { AppFunctionComponent } from "../../../types"

interface FormFieldProps {
  name: Field | string
  validation?: Record<string, any>
}

export const InputField: AppFunctionComponent<
  FormFieldProps & ComponentProps<typeof InputWithError>
> = ({ name, validation, ...props }) => {
  const { register, getValues, errors } = useFormContext()

  return (
    <InputWithError
      {...props}
      name={name}
      inputRef={validation ? register(validation) : register}
      defaultValue={getValues(name)}
      error={get(errors, name)?.message}
    />
  )
}

export const TextareaField: AppFunctionComponent<
  FormFieldProps & ComponentProps<typeof TextareaWithError>
> = ({ name, validation, ...props }) => {
  const { register, getValues, errors } = useFormContext()

  return (
    <TextareaWithError
      {...props}
      name={name}
      inputRef={validation ? register(validation) : register}
      defaultValue={getValues(name)}
      error={get(errors, name)?.message}
    />
  )
}

export const SelectField: AppFunctionComponent<
  FormFieldProps & ComponentProps<typeof Select>
> = ({ name, validation, ...props }) => {
  const { register, getValues, errors } = useFormContext()

  return (
    <Select
      {...props}
      name={name}
      selectRef={validation ? register(validation) : register}
      value={getValues(name)}
      error={get(errors, name)?.message}
    />
  )
}

export const CheckboxField: AppFunctionComponent<
  FormFieldProps & ComponentProps<typeof Checkbox>
> = ({ name, validation, ...props }) => {
  const { register, getValues, setValue, errors } = useFormContext()

  const changeValue = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(name, event.target.checked)
  }

  return (
    <Checkbox
      {...props}
      name={name}
      checkboxRef={validation ? register(validation) : register}
      checked={getValues(name)}
      onChange={changeValue}
      error={get(errors, name)?.message}
    />
  )
}
